/** Normaliza base URL e compara prefixo de requisição HTTP. */
export function startsWithApiBase(requestUrl: string, apiBaseUrl: string): boolean {
  const normalizedBase = apiBaseUrl.replace(/\/$/, '');
  const normalizedRequest = requestUrl.split('?')[0].replace(/\/$/, '');
  return normalizedRequest === normalizedBase || normalizedRequest.startsWith(`${normalizedBase}/`);
}

export function joinApiPath(baseUrl: string, path: string): string {
  const normalizedBase = baseUrl.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}
